import { render, staticRenderFns } from "./FormLayouts.vue?vue&type=template&id=08b49fe8&"
import script from "./FormLayouts.vue?vue&type=script&lang=js&"
export * from "./FormLayouts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports